import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PackageStatusLogEntity } from '../../domain/entities/PackageStatusLogEntity'
import type { PackageStatusLogDtoAdmin } from '@/backend/market'

export class PackageStatusLogModel extends PackageStatusLogEntity {
  constructor(dataDto: PackageStatusLogDtoAdmin) {
    super()
    mapEntityProperties<PackageStatusLogEntity>(this, dataDto)
  }
}
